<template lang="pug">
div
  app-divider(label="Imóvel")
  el-row.pad5
    el-col(:span="12" v-if="imovel.possuiCar || imovel.numeroReciboCar")
      p
        span.label Número do recibo:
        span.labelNumeroRecibo  &nbsp {{filterNull(imovel.numeroReciboCar)}}
    el-col(:span="12" v-if="!imovel.possuiCar && !imovel.numeroReciboCar")
      p
        span.label Número do imóvel:
        span.labelNumeroRecibo  &nbsp {{filterNull(imovel.nome)}}
    el-col(:span="12" v-if="!imovel.possuiCar && !imovel.numeroReciboCar")
      p
        span.label Município do imóvel:
        span.labelNumeroRecibo  &nbsp {{filterNull(imovel.municipio.nome)}}
    el-col(:span="12" v-if="!imovel.possuiCar && !imovel.numeroReciboCar")
      p
        span.label Área do imóvel:
        span.labelNumeroRecibo  &nbsp {{filterNull(imovel.area)}}
    el-col(:span="12" v-if="!imovel.possuiCar && !imovel.numeroReciboCar")
      p
        span.label Vias de acesso/localização:
        span.labelNumeroRecibo  &nbsp {{filterNull(imovel.descricaoAcesso)}}
    el-col(:span="12", v-if="inputsExtraCadastro.imovel.nomeImovelPropriedade")
      p
        span.label Nome do imóvel/Propriedade:
        span &nbsp {{imovel.nomeImovelPropriedade}}
    el-col(:span="12")
      p
        span.label Tempo de ocupação:
        span &nbsp {{filterNull(imovel.tempoOcupacao)}} ano(s)
    el-col(:span="12")
      p
        span.label Há ocupantes anteriores:
        span &nbsp {{hasOcupantesAnteriores}}
    el-col(:span="12" v-if="tipo === 'ONEROSO'")
      p
        span.label {{`Possui outros imóveis no ${ESTADO}:`}}
        span &nbsp {{hasOutrosImoveis}}
    el-col(:span="12")
      p
        span.label Há conflitos no imóvel:
        span &nbsp {{hasConflitos}}
    el-col(:span="12")
      p(v-if="imovel.conflitos")
        span.label Nº do processo judicial:
        span &nbsp {{filterNull(imovel.numeroProcessoJudicial)}}
  el-row.pad5(v-if="imovel.documentos")
    app-resumo-documentos.margin-top(:documentos="imovel.documentos" codigoCadastro="imovel")
  el-row.pad5(v-if="imovel.termo")
    el-checkbox(v-model="imovel.termo" :required="true" :disabled="true")
    span &nbsp {{formatarMensagem()}}

</template>
<script>
import AppDivider from '@/components/AppDivider'
import AppResumoDocumentos from './resumos/AppResumoDocumentos'
import { mapState } from 'vuex'
const {inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDivider,
    AppResumoDocumentos
  },
  props: {
    imovel: {
      type: Object,
      required: true
    },
    cadastro: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      inputsExtraCadastro
    }
  },
  computed: {
    ...mapState({
      ESTADO: state => state.userInterface.dadosEstado.ESTADO
    }),
    hasOcupantesAnteriores () {
      if (this.imovel.ocupantesAnteriores !== null) {
        return this.imovel.ocupantesAnteriores ? 'Sim' : 'Não'
      }
      return '-'
    },
    hasOutrosImoveis () {
      if (this.imovel.possuiImovel !== null) {
        return this.imovel.possuiImovel ? 'Sim' : 'Não'
      }
      return '-'
    },
    hasConflitos () {
      if (this.imovel.conflitos !== null) {
        return this.imovel.conflitos ? 'Sim' : 'Não'
      }
      return '-'
    }
  },
  methods: {
    filterNull (atributo) {
      return (atributo !== null && atributo !== '') ? atributo : '-'
    },
    formatarMensagem () {
      const interessado = this.cadastro.interessado
      const imovel = this.cadastro.imovel
      const isCpfOrCnpj = interessado?.pessoa?.isPessoaFisica ? 'CPF' : 'CNPJ'
      const interessadoNomeOrRazaoSocial = interessado?.pessoa?.isPessoaFisica
        ? interessado.pessoa.pessoaFisica.nome
        : interessado.pessoa.pessoaJuridica.razaoSocial
      const cpfOrCnpj = interessado?.pessoa?.isPessoaFisica
        ? interessado.pessoa.pessoaFisica.cpf
        : interessado.pessoa.pessoaJuridica.cnpj
      return `Eu, ${interessadoNomeOrRazaoSocial}, ${isCpfOrCnpj} nº ${cpfOrCnpj},
        DECLARO para os devidos fins, sob as penas da lei, que ocupo imóvel rural identificado neste requerimento do Instituto de Terras do Pará – ITERPA,
        no município de ${interessado.pessoa.endereco.nome},
        tornando-o produtivo há ${imovel.tempoOcupacao} anos,
        e preencho os requisitos estabelecidos na Lei 7.289/2009 e demais normas que a regulamentam.`
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad5 {
  padding: 25px 10px;
}

@media (max-width: 780px) {
  .pad5 {
    display: flex;
    flex-direction: column;
    width: 460px;
  }

  .labelNumeroRecibo {
    word-break: break-all;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/ResumoImovel.vue